import React from 'react';
import styled from 'styled-components';
import SearchIcon from '@material-ui/icons/Search';
import { Button } from '@material-ui/core';

interface FilterProps {
  filter: string;
  setFilter: (filter: string) => void;
  availableLetters: string[];
  setActiveLetter: (letter: string) => void;
  activeLetter: string;
}

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto 20px;
  padding: 10px;
  width: 100%;
  max-width: 800px;
  border: 1px solid #ccc;
  border-radius: 7px;
  background-color: #fff;
  max-width: 100%;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.41px;
  text-align: left;

  @media (max-width: 768px) {
    padding: 8px;
  }
`;

const FilterIcon = styled(SearchIcon)`
  margin-right: 10px;
  color: #ccc;
`;

const FilterInput = styled.input`
  border: none;
  flex: 1;
  font-size: 16px;
  &:focus {
    outline: none;
  }
`;

const Title = styled.h4`
  font-family: Roboto;
  font-weight: 400;
  text-align: left;
  margin-bottom: 20px;
  font-size: 18px;

  @media (max-width: 768px) {
    margin-bottom: 10px;
    font-family: Roboto;
    font-weight: 400;
    text-align: left;
    font-size: 16px;
  }
`;

const LetterFilterContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  flex-direction: column;
`;

const LetterButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
  width: 100%;
`;

const Subtitle = styled.h5`
  font-family: Roboto;
  font-weight: 400;
  text-align: left;
  margin-bottom: 20px;
  font-size: 16px;
  width: 100%;

  @media (max-width: 768px) {
    margin-bottom: 10px;
    font-family: Roboto;
    font-weight: 400;
    text-align: left;
    font-size: 16px;
  }
`;

export function Filter({ filter, setFilter, availableLetters, setActiveLetter, activeLetter }: FilterProps) {
  return (
    <>
      <Title>
        Encontre aqui a bula do medicamento e todas as informações necessárias para o uso
        consciente e informado, contribuindo para o bem-estar e saúde do paciente.
      </Title>
      <FilterContainer>
        <FilterIcon />
        <FilterInput
          type="text"
          placeholder="Buscar medicamento"
          value={filter}
          onChange={(e) => { setFilter(e.target.value) }}
        />
      </FilterContainer>
      <LetterFilterContainer>
        <Subtitle>
          Se preferir, escolha uma letra abaixo para ver os medicamentos que possuem bulas.
        </Subtitle>
        <LetterButtonsContainer>
          {availableLetters.map((letter) => (
            <Button
              key={letter}
              variant={activeLetter === letter ? 'contained' : 'outlined'}
              color={activeLetter === letter ? 'primary' : 'default'}
              onClick={() =>
                setActiveLetter(activeLetter === letter ? '' : letter) 
              }
              style={{ borderRadius: 8, minWidth: 40, height: 40 }}
            >
              {letter}
            </Button>
          ))}
        </LetterButtonsContainer>
      </LetterFilterContainer>
    </>
  );
}
